import RootErrorBoundaries from './RootErrorBoundaries';
import GlobalProvider from 'context/GlobalProvider';
import combineProviders from 'context/combineProviders';
import { RouteApp } from 'routes';

import './App.css';

/** Combine providers */
const Providers = combineProviders([
  GlobalProvider,
]);

/**
 * Representation of Devta website structure in general.
 *
 * Please don't add any complex logic at this component, only new component
 * render representing our website layer
 */
function App() {
  return (
    <RootErrorBoundaries>
      <Providers>
        <RouteApp />
      </Providers>
    </RootErrorBoundaries>
  );
}

export default App;
